import type { WavespeedModelConfig } from '../../types';
import { hasImageInput, resolveImageSize, clampTo } from '../../../tools';

export const zimageConfigs: Record<string, WavespeedModelConfig> = {
    'wavespeed-ai/z-image/turbo': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/z-image/turbo
        apiPath: '/wavespeed-ai/z-image/turbo',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    size: aspectRatio === 'match' ? undefined : resolveImageSize(
                        clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo-1024'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 图片 URL
                    image: image_urls[0],
                    // 可选参数
                    strength: typeof providerOptions?.strength === 'number' ? providerOptions.strength : 0.6,
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg', 'webp'] as const,
                        'png',
                    ),
                };
            } else {
                return {
                    prompt: prompt,
                    size: resolveImageSize(
                        clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo-1024'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg', 'webp'] as const,
                        'png',
                    ),
                };
            }
        },
    },
    'wavespeed-ai/z-image/base': {
        // https://wavespeed.ai/models/wavespeed-ai/z-image/base
        apiPath: '/wavespeed-ai/z-image/base',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    prompt: prompt,
                    size: aspectRatio === 'match' ? undefined : resolveImageSize(
                        clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo-1024'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 图片 URL
                    image: image_urls[0],
                    // 可选参数
                    negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                    strength: typeof providerOptions?.strength === 'number' ? providerOptions.strength : 0.6,
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg', 'webp'] as const,
                        'png',
                    ),
                };
            } else {
                return {
                    prompt: prompt,
                    size: resolveImageSize(
                        clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), 'z-image-turbo-1024'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 可选参数
                    negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg', 'webp'] as const,
                        'png',
                    ),
                };
            }
        },
    },
};